import { FIELD_TYPES } from "constants/template-field-type";
import FaqQuestionFieldsConfig from "segments/desktop/core-components/faq-question/fields-config";

const ALLOWED_COLORS = ["riverstone"];

export default {
  type: FIELD_TYPES.NESTED,
  label: "Frequently Asked Questions",
  fields: {
    title: {
      type: FIELD_TYPES.TEXT,
      label: "Title (text or translation key)",
      translatable: true
    },
    questions: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Questions",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: FaqQuestionFieldsConfig
      }
    },
    theme: {
      type: FIELD_TYPES.COLOR_PICKER,
      label: "Theme",
      possibleColors: ALLOWED_COLORS
    }
  }
};
